import { render } from "./MyselfSetting.vue?vue&type=template&id=9f28940a"
import script from "./MyselfSetting.vue?vue&type=script&lang=js"
export * from "./MyselfSetting.vue?vue&type=script&lang=js"

import exportComponent from "/home/rocky/dialogue_game2/dialogue_game/website/enmusubi/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__